export default {
    '29b2bf83-81b2-4ff5-b00c-e8acbca6403f': '',
    'cfb48afd-e0a1-47b0-8de0-d7feccc943dc': '🇦🇩',
    'fef3c7f5-240f-472f-b65d-e0672f42af03': '🇦🇱',
    '189b5627-e5b3-4890-88ab-b19199933578': '🇦🇲',
    '10903273-59cd-4005-852e-7c7ad35e4ee0': '🇦🇹',
    '0cd684c2-adc6-487f-a589-8174126d20cb': '🇧🇦',
    'e1d2d3ef-3da3-40c9-8e7c-b244f9941ccd': '🇧🇪',
    '9d8a9c7a-e37a-4e4b-be5d-7b7469435ae3': '🇧🇬',
    '7f293f88-be12-4a86-9c73-91495892de76': '🇧🇾',
    '742ea9ce-b92a-4268-b720-12182a73b5c9': '🇨🇭',
    'c8b41fad-fbf2-4123-8576-f075b25adcf2': '🇨🇾',
    '728b01cb-e3eb-4887-b7cf-9c0a169c6e8f': '🇨🇿',
    'cabe9699-fe31-4322-a22c-e95162a2c2fa': '🇩🇪',
    '017a7901-dea9-444e-9b10-d710b499f02a': '🇩🇰',
    '91a381f1-6948-451e-94ae-07af42b10e4f': '🇪🇪',
    '8aee7b2e-a89c-429c-8951-28ba368375ef': '🇪🇸',
    '10135b75-284f-49f4-9638-4250f9f7656b': '🇫🇮',
    'cb350222-71a9-46e6-b770-ef47e046e550': '🇫🇴',
    'ca10377e-c9e4-441c-a28c-668a6cb3a70a': '🇫🇷',
    '05ad1e2a-d94d-4015-92e4-a5515a7a0af7': '🇬🇧',
    '972fac2e-130a-49e0-b782-e0671424465d': '🇬🇪',
    '475bf1c3-143f-4864-aeda-ec7839995c52': '🇬🇮',
    '66909c29-64b5-49b4-8969-04168603656e': '🇬🇱',
    '50db264f-2216-4c4e-81b0-d811d20fce0c': '🇬🇷',
    '534f43a1-80d1-4a9b-9c64-dbb51e7342bb': '🇭🇷',
    '2cd2f1ce-0838-4b61-b80a-9f91af81ed2e': '🇭🇺',
    '5ff0eea4-50ca-4c23-8eac-65f22a862aa4': '🇮🇪',
    '728efb57-9812-4fce-9e0a-7c38ebe02a5b': '🇮🇱',
    'e9386012-0920-434a-9fcf-6a47615b68e1': '🇮🇸',
    'df517196-3fbb-4ada-8b0f-9ca468c9fb8f': '🇮🇹',
    '3ada9815-e39c-4dc9-a4f8-05fae3fad86c': '🇱🇮',
    '0bb92f18-df8e-4d53-a09b-d5f9d82c2ef7': '🇱🇹',
    '71e9de68-ac77-45a6-b818-cd47175a1f2d': '🇱🇺',
    '932fa164-e443-4925-b619-6a26f50c0a6f': '🇱🇻',
    '54d7b4dc-17f1-48da-b3a3-c38dff224eed': '🇲🇨',
    '82681779-84e2-407f-b091-4957f648d7cc': '🇲🇩',
    'da060af8-b5d9-4941-a4f3-475f4535f187': '🇲🇰',
    '75bf91ce-12df-4bd2-8106-a1200134da21': '🇲🇹',
    '2fc57ebf-82db-4db4-b8bc-42e10ed4c1ae': '🇳🇱',
    'de400329-9cbb-4f55-be64-8c0cde38cfb1': '🇳🇴',
    '211d8682-7dab-4f2d-ba13-57d9763ea89c': '🇵🇱',
    '551bb399-08c0-4d68-81b2-ab9fbfc90a3c': '🇵🇹',
    'de6c8aa9-daec-4a35-874f-56a727162419': '🇷🇴',
    '2fab7293-2b0d-4987-a12e-d2fad38bb2e4': '🇸🇪',
    'b8bb395b-6add-4c9c-a9cc-1acf20a01350': '🇸🇮',
    '3e7f5cb9-46a3-4ba2-a84c-8b972ccb96b0': '🇸🇰',
    'f06873ef-96db-4832-8b1f-d8ed6c980709': '🇸🇲',
    '8d21d5b7-4d7d-46d3-8cd0-8dbdace461c2': '🇹🇷',
    'f7b85134-2227-475e-afa8-253d9256e15c': '🇺🇦',
    '14d7452b-060e-453b-9f78-2a93b3a11a71': '🇷🇸',
    '348443d3-ccb7-4420-8806-3db71a5daad9': '🇲🇪',
    '51e550ac-b46c-436f-ab11-10de09fd18c4': '🇬🇬',
    '8c0e74a5-52ca-4d78-a61e-b9161c537ba1': '🇮🇲',
    '4deaad99-8e4b-4f8e-9c3d-54958380a166': '🇷🇺',
    'd1a41357-4471-4edb-bad7-b6e345d44411': '🇯🇪',
    'c0c52482-139d-49c2-b413-3239dbd2c473': '🇧🇲',
    '347cbd93-befd-4f2c-8f68-23e7ecd3d08c': '🇨🇦',
    'c1c523ad-b669-40d5-88c9-64d0b1ba353f': '🇵🇲',
    'f813b1f8-a70d-495a-993a-c34b7eb414a0': '🇺🇸',
    '369c9cca-4f01-4852-a8af-9e2ec881091c': '🇦🇬',
    'f1332226-7f66-44c5-a1f8-aa5955ff30bc': '🇦🇮',
    'dbb79a7e-0a5a-4565-9647-42985cdb2be8': '🇦🇷',
    'fabffb99-eea5-4c90-b871-fd20320dca17': '🇦🇼',
    '75600772-06cc-452e-a0c0-aa9d00097233': '🇧🇧',
    '6be0fec4-e86d-4d9a-93eb-9dedb25c5ea4': '🇧🇴',
    'a1b543f1-7680-4817-bce6-2c79dbb5dbe4': '🇧🇷',
    'f6b0e445-b110-41c2-81df-b5ab025b03e6': '🇧🇸',
    '35cd50d2-3f24-45f9-b459-f39c5eba8358': '🇧🇻',
    'fba4ad5c-d692-4d96-a2dc-33b7e56f880a': '🇧🇿',
    '6e065f93-1d1f-4938-b662-ce92b6f86b5c': '🇨🇱',
    '22d0e688-598f-4ced-b17b-7146bfe7e41e': '🇨🇴',
    '493d5dca-a42b-4540-afb9-e75c4579f6e6': '🇨🇷',
    'ad8761bb-1ac8-4f65-9c6f-c4f96afddab0': '🇨🇺',
    '5660f0c2-3fd2-4c9c-a649-8364fcc90e16': '🇩🇲',
    '8917bc79-32d8-42ad-8571-de478258ef85': '🇩🇴',
    'a7e67a0a-db31-4cb0-8ae1-098a8ef48eb1': '🇪🇨',
    'a05d9b5a-55d1-40c6-8035-3345ebd6b6e2': '🇬🇩',
    'c34f8351-3e57-4696-bbad-4857ad7cf56a': '🇬🇫',
    '81f9c603-a7fc-48a7-ad02-6157b5ad34bf': '🇬🇵',
    '0a42101a-7823-4f23-9cdf-b16119e4da7f': '🇬🇹',
    'ec508de6-c539-47ab-8164-c12c80887dcc': '🇬🇾',
    '3348f837-d184-4351-8108-63f0c6bcaed6': '🇭🇳',
    '3db33aba-1a50-4030-af0d-7da63a3f25bf': '🇭🇹',
    '2442d95d-6340-41e0-8194-db001b07bbc9': '🇯🇲',
    '1eea82a5-a6ee-4d05-a2c4-24bc6c6f72fe': '🇰🇳',
    '5fb40864-3c54-4fcd-b032-c64d876da3ac': '🇰🇾',
    'aba3e00b-c8bf-45b1-88de-803170d1b4cc': '🇱🇨',
    '1b411459-91fa-40c4-a7b4-a45e78b63d80': '🇲🇶',
    '102818cb-792d-4db6-a3eb-f36be475d620': '🇲🇸',
    'fb674473-d02c-480a-ba54-a3f212970270': '🇲🇽',
    'fd18799f-5b66-468d-a332-f4914ebe222d': '🇳🇮',
    '3bfaa3a6-1073-4708-8a06-742b5856d183': '🇵🇦',
    '32c33917-a5b1-4028-87b9-e111efe3594c': '🇵🇪',
    'bf9108e4-cc9b-4d72-9a0f-9c74fc4d2aeb': '🇵🇷',
    '2a844ce5-8e82-471f-818f-084278c9c05a': '🇵🇾',
    '2d07ec0f-8ce8-4e58-babe-671db1686b5e': '🇸🇷',
    '746bb7d1-1b63-4971-9204-a5e02de6256c': '🇸🇻',
    'c5b84896-f899-462a-aff7-23eba3cf6f2f': '🇹🇹',
    'a9276fcf-97d8-4738-88d3-95fb30a67297': '🇺🇾',
    '5ebae5f6-a62e-4f10-abb1-34cbbfc27a82': '🇻🇨',
    'e361a34b-0f75-442f-8250-c9b241723e1b': '🇻🇪',
    'a24d5805-1160-40ce-a5c6-7c5fe0b75384': '🇻🇬',
    '2c49f608-6a13-4365-8758-ca83ebcb450e': '🇻🇮',
    '9b6412ce-5306-46ba-ba5e-d8f47a670af2': '🇹🇨',
    'd2fae911-ab1e-495f-b009-39179bc45ea6': '',
    'd09a6a87-8498-44a0-b2e1-f932b346c576': '🇦🇴',
    '03d2d780-454d-48c3-a7ff-e4dffb718812': '🇧🇫',
    '7aefc059-7145-4268-b841-42590ce3e33f': '🇧🇮',
    '2c69ce6f-4673-479e-aed2-1152ce477c82': '🇧🇯',
    '32a910b3-bbd0-404e-b3ee-b7bd13924d4e': '🇧🇼',
    '7bfc9edf-4755-4275-a32f-a0dd7188d31d': '🇨🇩',
    'ea44e2a4-eb79-47b8-b880-7fb93f3cbdde': '🇨🇫',
    'dd61205d-2cd3-4c2b-84c9-0bbaa506e42d': '🇨🇬',
    '0c94f908-bcd8-4260-b6ce-104f2ef131a7': '🇨🇮',
    '8a26aa64-2837-43eb-b62e-22d5d435cad9': '🇨🇲',
    '8564af21-0b9d-49d7-8795-62e3d1a403ae': '🇨🇻',
    '6df5285e-680e-4769-b204-6c38e3191ab8': '🇪🇭',
    '435d4f6d-f765-48a4-ad7d-a590b7971186': '🇪🇷',
    'b0716fdf-fc92-4f0f-ac36-983d8c37dbfa': '🇪🇹',
    'ffffb17c-a94f-4590-8f09-91afa11dcf28': '🇬🇦',
    'dbbf20a1-31ea-444c-9404-f573d0c58d63': '🇬🇭',
    'cd7468b0-603d-42f3-9c00-d39fcb22152f': '🇬🇲',
    'e182fa2b-f25e-4e81-ac0c-7cd343523996': '🇬🇳',
    '83deeec3-eb54-444b-a83e-905e99279039': '🇬🇶',
    'e5caf168-5cec-4eeb-9974-4d7ac31431bf': '🇬🇼',
    'c02127f3-d4f5-4a93-8298-b99cb1848976': '🇰🇪',
    'd97cdd12-c936-47d1-b6ef-961ad429951b': '🇱🇷',
    'a255f714-e324-4cdd-8496-ff00276e88a5': '🇱🇸',
    'c49f169a-a826-4662-b45c-b469629ef612': '🇲🇬',
    'c388726e-c181-4454-9941-905ec0a96c13': '🇲🇱',
    'b90ab4ad-ad8d-4380-8332-b1f99fbbf390': '🇲🇺',
    '4dda159f-d8fb-49e3-b4cf-25630c4de117': '🇲🇼',
    'a0ce4824-4158-4a4d-b561-8968e6bfb72a': '🇲🇿',
    '260f3b88-b189-4521-a289-695b4017a331': '🇳🇦',
    '02b0fef7-7851-470b-b9f6-a60e4a4fa0f9': '🇳🇪',
    '72eb2fe1-3f8a-4329-b0e3-47825fdd87af': '🇳🇬',
    '62b5fe31-8c3a-48d8-af23-f6bebba59725': '🇷🇼',
    '45697787-fe3b-41e6-b63c-e9e678bfefda': '🇸🇨',
    '891ff910-886f-4a95-abe1-dc0704730bf0': '🇸🇸',
    '71419424-aa47-482d-96c1-c722804f2543': '🇸🇭',
    '40d8452b-6357-48ff-bf9b-914524ac5c80': '🇸🇱',
    'd4649399-b8b3-4329-9f04-3e9687021f91': '🇸🇳',
    '0dfc3126-1f81-4163-991c-db7535302a5a': '🇸🇹',
    '2f81ea40-6816-468a-8eeb-7274dedffc4c': '🇸🇿',
    'c947b598-f352-4130-b1c2-466e63637f3c': '🇹🇩',
    '7b0c5ad0-a7e2-4f53-9f40-bda56223a053': '🇹🇬',
    '22b6ce46-cbce-4bf4-8ecd-12f74eedc544': '🇹🇿',
    'bbb35f20-bbc1-4260-847d-672e29a4b64d': '🇺🇬',
    '1aad2d92-2577-4d23-a71f-8c468cfb9942': '🇾🇹',
    '81f5978b-66e1-4dae-93b6-0a0c6e21548c': '🇿🇦',
    '1beb1bc2-5485-4c01-b897-fc3d8115462c': '🇿🇲',
    '78ce30ea-50c0-4432-b788-5cb92b6ccfd9': '🇿🇼',
    'cfcc5f1f-8143-4cfe-acf4-dfb1dec32820': '🇦🇪',
    '17e98a89-66a9-453c-8927-8ef47c0eb2a3': '🇧🇭',
    'cc86f04c-dc86-4473-a619-742ba255a8e2': '🇩🇯',
    'd48c9176-382e-4157-aaca-de27b361991c': '🇩🇿',
    '96890405-6b24-4bef-9943-77a5de4f4493': '🇪🇬',
    '6e2139c4-fde9-4237-9e22-65b49e7a217a': '🇮🇶',
    'e1d6b845-eb70-425e-82be-41501c0c42fb': '🇯🇴',
    '62790d59-be01-4025-873f-6a33e80923fd': '🇰🇲',
    '05be5086-b1e4-4a86-9837-b877ea0fca13': '🇰🇼',
    '23e080b8-6e5f-4a9a-b4cf-dbf2747ad905': '🇱🇧',
    '170a6a5b-a672-48a6-a429-3877ad397581': '🇱🇾',
    'bc20f1cd-494b-479d-964b-6c93ed5e6672': '🇲🇦',
    'a6e06f47-ace5-499d-b199-d49f99af3e8a': '🇲🇷',
    '79d04a5a-74b1-43ee-861f-0b456016065f': '🇴🇲',
    'a94a91ff-fe49-4051-9f9a-5a5e1e233dd5': '🇵🇸',
    'fd8a6b7d-ce50-434d-a4cc-b194411bff96': '🇶🇦',
    '6c397302-2b1c-4957-a2a6-aee7d4bfdc9f': '🇸🇦',
    '6d29bd8b-822d-4b3b-89e2-f2009497eb0e': '🇸🇩',
    '613ca451-77c2-4d92-8d76-1e719279dc23': '🇸🇴',
    'a6f4884f-d615-4ffe-a768-3dac93673704': '🇹🇳',
    '95d4c7da-71a8-45b9-b63e-29cbf9562388': '🇾🇪',
    'a5d9f475-6e05-4811-ac37-866c9eaa575f': '🇦🇫',
    'b98e9e18-d539-43e1-9fa6-e6992c33d599': '🇦🇶',
    '044198e7-d3f6-4ec1-a98f-dc95ed2021ba': '🇦🇸',
    '80536e22-dde8-467a-85b2-29f70fc138d2': '🇦🇺',
    '8a022f0e-988f-4058-bc72-511b920e2894': '🇦🇿',
    '54ae35e3-9bff-4930-b6dd-e17ee5f8e46b': '🇧🇩',
    '64501b59-e180-42d1-a3ec-ef922583f691': '🇧🇳',
    'b2eee6e4-6911-4798-a83f-0462d407197c': '🇧🇹',
    'cbe1f283-4bbb-4f69-91ac-a17215e33aa8': '🇨🇰',
    '143283f3-606d-403d-b5da-23392a6a0a8d': '🇨🇳',
    '56ca4f8d-9b09-4a54-b214-9bfbc29e4cb9': '🇨🇽',
    '3bfe84c8-ae7c-4dd9-a7a4-6831e1ff149b': '🇫🇯',
    'a8d4030b-e983-4453-be8b-06eaf41d348a': '🇫🇲',
    '6eb327bb-fff8-4c5a-9e0b-a46fef1f3b96': '🇬🇺',
    '4ba92116-fd2e-4c30-9949-d4ab7a6d8fb7': '🇭🇰',
    'bda41175-62d3-4e98-b602-41ff3c4f493d': '🇭🇲',
    '76071cea-dcf0-484d-8908-7ed246dda9b2': '🇮🇩',
    'b16721b7-c2eb-4a67-85f7-6d14f3164e78': '🇮🇳',
    '5c7f07d0-b377-44ab-a748-bc0807f76f83': '🇮🇷',
    'b9d48c21-f258-4f00-801d-bf5e0be2d271': '🇯🇵',
    '2f140198-dd12-4dd0-932c-4e69470a0d20': '🇰🇬',
    '53254954-80f9-400f-82d1-5a90cb169a05': '🇰🇭',
    '9f1cc3f1-3428-4620-9b59-58e834ddd77a': '🇰🇮',
    'c37408e1-1928-4527-992c-64604beb28ea': '🇰🇵',
    '2dae715c-692d-4f7a-b320-d92bcaa853a7': '🇰🇷',
    '0dceff59-9d4d-4788-bf67-72875a9aecb1': '🇰🇿',
    '7f6d7b12-5d0e-4865-91c9-dbc24ef9a7ff': '🇱🇦',
    'e76dd36b-7afb-42c8-bcff-79591f96cc0d': '🇱🇰',
    '75b456d7-71d1-40f5-aa94-515877b42633': '🇲🇭',
    '7505ee56-5914-469a-b823-7f11b4005ef3': '🇲🇲',
    'b01afbdd-70c3-4a42-8875-37c8fda3d08f': '🇲🇳',
    'a7848938-564c-41c6-b2f3-1e653ae5a093': '🇲🇴',
    '4324b7be-731a-471c-b44d-48733227952a': '🇲🇵',
    '8b299ee8-bf92-4fd5-b62f-a5a723fd5963': '🇲🇻',
    'd40fa125-507c-483e-ba2e-95dc8392a7e5': '🇲🇾',
    '343c3426-a044-4c07-8447-bcc6b8ee71b6': '🇳🇨',
    '6cbad4c6-619c-4883-ad08-2d72901be18f': '🇳🇫',
    'cc9f7a25-e11d-4ab6-bc93-87e7c086f1d4': '🇳🇵',
    '75bf2d02-999b-4ece-a8f4-3fbb59679372': '🇳🇷',
    'd903890f-cd50-4957-b2ee-61200262dced': '🇳🇺',
    'c0dbbfcb-b1a7-4970-961d-4632e647f9fb': '🇳🇿',
    '5687fb6b-5be3-4204-82af-fe658c037a67': '🇵🇬',
    'fb7e8562-70d4-4333-aa44-52b4d5e090d0': '🇵🇭',
    '6511bc05-3c90-4e2a-b902-fd4875869d0a': '🇵🇰',
    '649edd43-bd60-4647-92ee-2f2bde760e26': '🇵🇳',
    'd52b09d5-ade6-4f92-92bb-3f0939dd8786': '🇵🇼',
    '9b2e2d92-31e9-4b4d-8fe7-da5d3089f917': '🇷🇪',
    '2c4f6c47-f742-4668-b839-5e5fad79b296': '🇸🇧',
    '9583f629-2d58-4517-b35e-13f4cf991b77': '🇸🇬',
    '14d672a5-22bf-477d-9e8b-5b6923ba27ab': '🇸🇾',
    '1b0d93d9-cb43-486c-a185-ef997bd5a11c': '🇹🇭',
    '4420c0ab-4ceb-40ca-9e8e-8b395ccf63af': '🇹🇯',
    'dd9f28f6-50cf-4443-8c70-ec4aa456d8c0': '🇹🇰',
    '0535ab15-d42d-4614-81da-d2ea4198c5d3': '🇹🇲',
    '32e69187-dc50-4255-8ce3-697b174d75f8': '🇹🇴',
    '2e9ef0f3-644b-4ea7-a100-19b16919a07c': '🇹🇱',
    '0b65ba0e-1a44-480a-86e3-ffb16d125943': '🇹🇻',
    'c8cb83f0-a433-4505-b48c-1626c6615adb': '🇹🇼',
    '18b83454-fcb4-4380-9b1a-01e42ba5caa8': '🇺🇿',
    '0a81808d-5900-4089-85d9-8ff594dd32f9': '🇻🇳',
    'e44572ec-d5a1-4a95-9f01-3140bd9d4a76': '🇻🇺',
    '52663dda-bc32-4521-af5c-8b8129e3638f': '🇼🇫',
    'e6392044-a98c-402b-82f9-02918c7b4284': '🇼🇸',
}
